import {$} from '../jquery-definition.js';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'flickity-bg-lazyload';
import 'flickity-imagesloaded';
import '@fancyapps/fancybox';

// make Flickity a jQuery plugin
Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );

$( '.image-carousel' ).each( function() {
	var $this = $( this );

	var $carousel = $this.flickity( {
		bgLazyLoad: 2,
		pageDots: true,
		prevNextButtons: false,
		contain: true,
		imagesLoaded: true,
		wrapAround: true,
		resize: true,
	} );

	var $previous = $this.parents( '.carousel-container' ).find( '.carousel-previous' );
	var $next = $this.parents( '.carousel-container' ).find( '.carousel-next' );

	$previous.on( 'click', function( clickEvent ) {
		$carousel.flickity( 'previous' );
	} );

	$next.on( 'click', function( clickEvent ) {
		$carousel.flickity( 'next' );
	} );
} );

$( '.timeline-carousel' ).each( function() {
	var $this = $( this );

	var $carousel = $this.flickity( {
		pageDots: false,
		prevNextButtons: false,
		contain: true,
		wrapAround: false,
		cellAlign: 'left',
		adaptiveHeight: false,
	} );

	var flkty = $carousel.data( 'flickity' );
	var selectedIndex = flkty.selectedIndex;
	var slideCount = flkty.slides.length;

	var $previous = $this.parents( '.carousel-container' ).find( '.carousel-previous' );
	var $next = $this.parents( '.carousel-container' ).find( '.carousel-next' );
	var $indicator = $this.parents( '.carousel-container' ).find( '.position-indicator' );

	$previous.on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();
		$carousel.flickity( 'previous' );
	} );

	$next.on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();
		$carousel.flickity( 'next' );
	} );

	$indicator.css( {
		'width': (100 / slideCount) * (flkty.selectedIndex + 1) + '%'
	} );

	$carousel.on( 'select.flickity', function() {
		// enable/disable previous/next buttons
		if ( !flkty.slides[ flkty.selectedIndex - 1 ] ) {
			$previous.attr( 'disabled', 'disabled' );
			$next.removeAttr( 'disabled' );
		} else if ( !flkty.slides[ flkty.selectedIndex + 1 ] ) {
			$next.attr( 'disabled', 'disabled' );
			$previous.removeAttr( 'disabled' );
		} else {
			$previous.removeAttr( 'disabled' );
			$next.removeAttr( 'disabled' );
		}

		$indicator.css( {
			'width': (100 / slideCount) * (flkty.selectedIndex + 1) + '%'
		} );
	} );
} );

$( '.card-carousel' ).each( function() {
	var $this = $( this );

	var $carousel = $this.flickity( {
		pageDots: false,
		prevNextButtons: false,
		contain: true,
		wrapAround: false,
		cellAlign: 'left',
		adaptiveHeight: true,
	} );

	var flkty = $carousel.data( 'flickity' );
	var selectedIndex = flkty.selectedIndex;
	var slideCount = flkty.slides.length;

	var $previous = $this.parents( '.carousel-container' ).find( '.carousel-previous' );
	var $next = $this.parents( '.carousel-container' ).find( '.carousel-next' );
	var $indicator = $this.parents( '.carousel-container' ).find( '.position-indicator' );

	$indicator.css( {
		'width': (100 / slideCount) * (flkty.selectedIndex + 1) + '%'
	} );

	$carousel.on( 'select.flickity', function() {
		// enable/disable previous/next buttons
		if ( !flkty.slides[ flkty.selectedIndex - 1 ] ) {
			$previous.attr( 'disabled', 'disabled' );
			$next.removeAttr( 'disabled' );
		} else if ( !flkty.slides[ flkty.selectedIndex + 1 ] ) {
			$next.attr( 'disabled', 'disabled' );
			$previous.removeAttr( 'disabled' );
		} else {
			$previous.removeAttr( 'disabled' );
			$next.removeAttr( 'disabled' );
		}

		$indicator.css( {
			'width': (100 / slideCount) * (flkty.selectedIndex + 1) + '%'
		} );
	} );
} );
